import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { type SbSharedRecentSalesOverview_creatorRootTransactions$key } from './__generated__/SbSharedRecentSalesOverview_creatorRootTransactions.graphql';

import { FormattedNumber } from 'dibs-react-intl';
import {
    recentSalesAveragePriceDetails,
    recentSalesPriceRangeDetails,
    recentSalesPriceRangeInfo,
} from '../SbSharedRecentSalesMessages/SbSharedRecentSalesMessages';

import styles from './SbSharedRecentSalesOverview.scss';

type Props = {
    creatorRootTransactions:
        | SbSharedRecentSalesOverview_creatorRootTransactions$key
        | null
        | undefined;
    currency: string;
};

export const SbSharedRecentSalesOverview: FC<Props> = ({
    creatorRootTransactions: CreatorRootTransactionsRef,
    currency,
}) => {
    const creatorRootTransactions = useFragment(
        graphql`
            fragment SbSharedRecentSalesOverview_creatorRootTransactions on CreatorRootTransactions {
                minPrice
                maxPrice
                averageSoldPrice
            }
        `,
        CreatorRootTransactionsRef
    );

    const averageSoldPrice = creatorRootTransactions?.averageSoldPrice;
    const transactionsMinPrice = creatorRootTransactions?.minPrice;
    const transactionsMaxPrice = creatorRootTransactions?.maxPrice;

    return (
        <table className={styles.overviewTable}>
            <tbody>
                {averageSoldPrice && (
                    <>
                        <tr className={styles.label}>
                            <td>
                                <FormattedNumber
                                    value={averageSoldPrice}
                                    style="currency"
                                    currency={currency}
                                    maximumFractionDigits={0}
                                    minimumFractionDigits={0}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className={styles.overviewTopRow}>
                                    {recentSalesAveragePriceDetails}
                                </div>
                            </td>
                        </tr>
                    </>
                )}
                {transactionsMinPrice && transactionsMaxPrice && (
                    <>
                        <tr className={styles.label}>
                            <td>
                                {recentSalesPriceRangeInfo({
                                    minPrice: transactionsMinPrice,
                                    maxPrice: transactionsMaxPrice,
                                    currency,
                                })}
                            </td>
                        </tr>
                        <tr>
                            <td>{recentSalesPriceRangeDetails}</td>
                        </tr>
                    </>
                )}
            </tbody>
        </table>
    );
};
